var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 18,
    viewBox: "0 0 23 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7436 5.48507C10.8114 5.48507 9.91735 5.85539 9.25816 6.51457C8.59898 7.17376 8.22865 8.0678 8.22865 9.00002C8.22865 9.93225 8.59898 10.8263 9.25816 11.4855C9.91735 12.1447 10.8114 12.515 11.7436 12.515C12.6758 12.515 13.5699 12.1447 14.2291 11.4855C14.8882 10.8263 15.2586 9.93225 15.2586 9.00002C15.2586 8.0678 14.8882 7.17376 14.2291 6.51457C13.5699 5.85539 12.6758 5.48507 11.7436 5.48507ZM10.5273 7.78374C10.8499 7.46116 11.2874 7.27994 11.7436 7.27994C12.1998 7.27994 12.6373 7.46116 12.9599 7.78374C13.2825 8.10632 13.4637 8.54383 13.4637 9.00002C13.4637 9.45622 13.2825 9.89373 12.9599 10.2163C12.6373 10.5389 12.1998 10.7201 11.7436 10.7201C11.2874 10.7201 10.8499 10.5389 10.5273 10.2163C10.2047 9.89373 10.0235 9.45622 10.0235 9.00002C10.0235 8.54383 10.2047 8.10632 10.5273 7.78374Z",
    fill: "#818385"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.7436 0.25C7.22529 0.25 3.61635 3.2093 0.849357 8.58956C0.716881 8.84715 0.716881 9.15285 0.849357 9.41044C3.61635 14.7907 7.22529 17.75 11.7436 17.75C16.2619 17.75 19.8708 14.7907 22.6378 9.41044C22.7703 9.15285 22.7703 8.84715 22.6378 8.58956C19.8708 3.2093 16.2619 0.25 11.7436 0.25ZM11.7436 15.9551C8.28208 15.9551 5.23386 13.8019 2.66095 9C5.23386 4.19809 8.28208 2.04487 11.7436 2.04487C15.2051 2.04487 18.2533 4.19809 20.8262 9C18.2533 13.8019 15.2051 15.9551 11.7436 15.9551Z",
    fill: "#818385"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconVisibility);
export default __webpack_public_path__ + "static/media/IconVisibility.16bc7e9f039dfb3c52318e303c789e6d.svg";
export { ForwardRef as ReactComponent };